import React from "react";
import { useField } from "react-final-form";
import {
  CreatePasswordField,
  GivenNameField,
  UsernameField
} from "../../shared/fields";
import SecretQuestionSelect from "../../secret-question-select";

const CoppaUpdateUserFormFields = () => {
  useField("isCoppa", {
    defaultValue: true
  });
  return (
    <>
      <GivenNameField />
      <UsernameField />
      <SecretQuestionSelect />
      <CreatePasswordField />
    </>
  );
};

export default CoppaUpdateUserFormFields;
